import type { IAnnouncement } from '$utils/interfaces/admin';
import { BaseService } from './utils/BaseService';

export class AdminService extends BaseService {
  createAnnouncement(body: string) {
    return this.client.send('/api/admin/announcement', {
      method: 'POST',
      body: { body },
    });
  }

  updateAnnouncement(announcementId: number, body: string) {
    // TODO - implement this
    return this.client.send('/api/admin/announcement', {
      method: 'PUT',
      body: { announcementId, body },
    });
  }

  listAnnouncements(
    limit = 6,
    offset = 0,
  ): Promise<{ announcements: IAnnouncement[]; hasMore: boolean }> {
    return this.client.send('/api/admin/announcements', {
      method: 'GET',
      query: { limit, offset },
    });
  }
}
